export default __webpack_public_path__ + "static/media/Tree3.dbb2ee04.png";